/*ReactJS*/
import React, { useState, useEffect, useContext } from 'react';
import { CSVLink } from 'react-csv';

/*Service*/
import {
  CreateSegregationPriorityRequest,
  UpdateSegregationPriorityRequest,
  ListSegregationPriorityRequest,
  DeleteSegregationPriorityRequest,
} from '../../../proto/reportpb/segregationpriority_grpc_web_pb.js';
import { ReadProfileRequest } from '../../../proto/admpb/profile_grpc_web_pb';
import { TableSettings } from '../../../proto/admpb/tablesettings_grpc_web_pb';

/*Toast Notification*/
import {
  notifySuccess,
  notifyInfo,
  notifyError,
} from 'components/Notification/Notification';

/*Material UI Components*/
import {
  Typography,
  Button,
  Modal,
  Backdrop,
  Fade,
  Box,
  TextField,
  MenuItem,
  InputLabel,
  Select,
  IconButton,
  Checkbox,
  Tooltip,
} from '@material-ui/core';

/*Material UI Confirm*/
import { useConfirm } from 'material-ui-confirm';

/*Material UI Table*/
import MUIDataTable from 'mui-datatables';

/*Icons*/
import {
  Add as AddIcon,
  Create as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from '@material-ui/icons';

/*Styles*/
import tableTheme from '../../../components/Table/TableStyle';
import { MuiThemeProvider } from '@material-ui/core/styles';
import useStyles from '../../../styles';

/*Moment JS*/
import moment from 'moment-timezone';
import { formatPbDate } from 'lib/fmt';

/*Custom components*/
import SymbolSelect from '../../../components/AutoComplete/Symbol';
import SearchButton from '../../../components/Button/Search';

import { ServiceContext } from 'context/ServiceContext';
import { useUserState } from 'context/UserContext';

/*Google Date*/
const google_date = require('../../../google/type/date_pb.js');

function saveSegregationPriority(
  segregationPriority,
  rows,
  isAdd,
  closeModal,
  symbol,
  startDate,
  endDate,
  priorityType,
  status,
  segregationPriorityId
) {
  if (!symbol) {
    notifyError('Symbol is required.');
    return;
  }
  if (!startDate) {
    notifyError('Start Date is required.');
    return;
  }
  if (!endDate) {
    notifyError('End Date required.');
    return;
  }
  if (priorityType === '') {
    notifyError('Priority Type is required.');
    return;
  }

  if (isAdd) {
    let addReq = new CreateSegregationPriorityRequest();
    addReq.setSymbol(symbol);
    addReq.setPriorityType(priorityType);

    if (startDate) {
      let gglStartDate = new google_date.Date();
      let [y, m, d] = startDate.split('-').map(Number);
      gglStartDate.setYear(y);
      gglStartDate.setMonth(m);
      gglStartDate.setDay(d);
      addReq.setStartDate(gglStartDate);
    }

    if (endDate) {
      let gglEndDate = new google_date.Date();
      let [y, m, d] = endDate.split('-').map(Number);
      gglEndDate.setYear(y);
      gglEndDate.setMonth(m);
      gglEndDate.setDay(d);
      addReq.setEndDate(gglEndDate);
    }

    segregationPriority.createSegregationPriority(addReq, {}, (err, res) => {
      if (err) {
        notifyError(err.message);
      } else {
        let obj = res.toObject().segregationPriority;
        let newSegregationPriority = {
          segregationPriorityId: obj.segregationPriorityId,
          originalCusip: obj.originalCusip,
          symbol: obj.symbol,
          cusip: obj.cusip,
          symbolDescription: obj.symbolDescription,
          status: obj.status,
          priorityType: obj.priorityType,
          startDate: formatPbDate(obj.startDate),
          endDate: formatPbDate(obj.endDate),
        };
        rows.push(newSegregationPriority);
        notifySuccess('New Segregation Priority has been added.');
        closeModal();
      }
    });
  } else {
    let updateReq = new UpdateSegregationPriorityRequest();
    updateReq.setSegregationPriorityId(segregationPriorityId);
    updateReq.setSymbol(symbol);
    updateReq.setPriorityType(priorityType);
    updateReq.setStatus(status);

    if (startDate) {
      let gglStartDate = new google_date.Date();
      let [y, m, d] = startDate.split('-').map(Number);
      gglStartDate.setYear(y);
      gglStartDate.setMonth(m);
      gglStartDate.setDay(d);
      updateReq.setStartDate(gglStartDate);
    }

    if (endDate) {
      let gglEndDate = new google_date.Date();
      let [y, m, d] = endDate.split('-').map(Number);
      gglEndDate.setYear(y);
      gglEndDate.setMonth(m);
      gglEndDate.setDay(d);
      updateReq.setEndDate(gglEndDate);
    }

    segregationPriority.updateSegregationPriority(updateReq, {}, (err) => {
      if (err) {
        notifyError(err.message);
      } else {
        for (let i = 0; i < rows.length; i++) {
          if (rows[i].segregationPriorityId === segregationPriorityId) {
            rows[i].status = status;
          }
        }
        notifySuccess('Segregation Priority has been updated.');
        closeModal();
      }
    });
  }
}

function removeSegregationPrioritySingle(
  segregationPriority,
  rows,
  segregationPriorityId,
  priorityType,
  symbol,
  confirm
) {
  confirm({
    description:
      "You are about to disable symbol '" +
      symbol +
      "' with priority type '" +
      (priorityType === 1 ? 'Seg First' : 'Seg Last') +
      "' in your system. Please confirm your action.",
    confirmationText: 'Yes, Disable',
  })
    .then(() => {
      let deleteReq = new DeleteSegregationPriorityRequest();
      deleteReq.setSegregationPriorityId(segregationPriorityId);

      segregationPriority.deleteSegregationPriority(deleteReq, {}, (err) => {
        if (err) {
          console.error(err.message);
          notifyError(err.messsage);
          return;
        }
        for (let c = 0; c < rows.length; c++) {
          if (rows[c].segregationPriorityId === segregationPriorityId) {
            rows[c].status = 'inactive';
          }
        }
        notifySuccess('Segregation Priority has been disabled');
      });
    })
    .catch(() => {
      // showToastMessage("error", "System error.");
    });
}

function removeSegregationPriority(
  segregationPriority,
  rows,
  ids,
  handleClick,
  confirm
) {
  if (ids.length < 1) {
    notifyError('No item is selected.');
    return;
  }

  confirm({
    description:
      'You are about to disable ' +
      ids.length +
      ' Segregation Priority in your system. Please confirm your action.',
    confirmationText: 'Yes, Disable',
  })
    .then(() => {
      ids.forEach(removeFunction);

      function removeFunction(item) {
        let deleteReq = new DeleteSegregationPriorityRequest();
        deleteReq.setSegregationPriorityId(item);

        segregationPriority.deleteSegregationPriority(deleteReq, {}, (err) => {
          if (err) {
            console.error(err.message);
            notifyError(err.message);
          }
          for (let c = 0; c < rows.length; c++) {
            if (rows[c].segregationPriorityId === item) {
              rows[c].status = 'inactive';
            }
          }
        });
      }
      handleClick('', '', true);
      notifySuccess(ids.length + ' Segregation Priority has bee disabled');
    })
    .catch(() => {
      /* ... */
    });
}

export default function SegregationPriorityTable({ params }) {
  var { googleAccount } = useUserState();

  const classes = useStyles();
  const confirm = useConfirm();

  const {
    segregationPriorityServiceClient: segregationPriority,
    profileServiceClient: systemDate,
    tableSettingsServiceClient: tableSettings,
  } = useContext(ServiceContext);

  const search = () => {
    const pathWithParams =
      currentPath +
      '?search=true' +
      (dateValue ? '&date=' + dateValue : '') +
      (symbolValue ? '&symbol=' + symbolValue : '') +
      (priorityTypeValue ? '&priorityType=' + priorityTypeValue : '') +
      (statusValue ? '&status=' + statusValue : '');
    window.history.pushState({}, null, pathWithParams);

    setLoading(true);
    console.log(priorityTypeValue);
    let list = new ListSegregationPriorityRequest();
    list.setSymbol(symbolValue);
    list.setPriorityType(priorityTypeValue);
    list.setStatus(statusValue);

    if (dateValue) {
      let gglDate = new google_date.Date();
      let [y, m, d] = dateValue.split('-').map(Number);
      gglDate.setYear(y);
      gglDate.setMonth(m);
      gglDate.setDay(d);
      list.setDate(gglDate);
    }

    segregationPriority.listSegregationPriority(list, {}, (err, res) => {
      if (err) {
        console.error(err);
        notifyError(err.message);
        setLoading(false);
        return;
      }

      const rows = res.toObject().segregationPrioritiesList.map((data) => ({
        startDate: formatPbDate(data.startDate),
        endDate: formatPbDate(data.endDate),
        symbol: data.symbol,
        symbolDescription: data.symbolDescription,
        cusip: data.cusip,
        priorityType: data.priorityType,
        status: data.status,
        segregationPriorityId: data.segregationPriorityId,
      }));

      setRows(rows);
      notifyInfo(rows.length + ' search results.');
      setLoading(false);
    });
  };

  const updateTableSettings = () => {
    let req = new TableSettings();
    req.setGoogleId(googleAccount.googleId);
    req.setPageName('Segregation Priority');
    req.setViewColumns(tableSetting.viewColumns.toString());

    tableSettings.updateTableSettings(req, {}, (err, res) => {
      if (err) {
        console.error(err);
        return;
      }
      notifySuccess('Table has been saved.');
    });
  };

  const [tableSetting, setTableSetting] = useState({
    load: true,
    viewColumns: [],
  });

  const [selected, setSelected] = React.useState([]);
  const [rowID, setRowID] = React.useState('');

  const columns = [
    {
      name: '',
      options: {
        draggable: false,
        resizable: false,
        print: false,
        searchable: false,
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          if (!rows[dataIndex]) {
            return;
          }

          const isItemSelected = isSelected(
            rows[dataIndex].segregationPriorityId
          );
          const labelId = `enhanced-table-checkbox-${dataIndex}`;

          return (
            <div className={classes.grdRow} style={{ margin: 0 }}>
              <div className={classes.grdCellNone}>
                <Checkbox
                  onClick={(event) =>
                    handleClick(event, rows[dataIndex].segregationPriorityId)
                  }
                  checked={isItemSelected}
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </div>
              <div className={classes.grdCellNone}>
                <Tooltip title="Disable" arrow>
                  <span>
                    <IconButton
                      aria-label="delete"
                      disabled={rows[dataIndex].status === 'inactive'}
                      onClick={() => {
                        removeSegregationPrioritySingle(
                          segregationPriority,
                          rows,
                          rows[dataIndex].segregationPriorityId,
                          rows[dataIndex].priorityType,
                          rows[dataIndex].symbol,
                          confirm
                        );
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              </div>
              <div className={classes.grdCellNone}>
                <Tooltip title="Edit" arrow>
                  <IconButton
                    aria-label="edit"
                    onClick={() => handleOpen(rows[dataIndex], false)}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          );
        },
        setCellProps: () => ({
          style: { padding: '2px 16px' },
        }),
      },
    },
    {
      name: 'symbol',
      label: 'Symbol',
    },
    {
      name: 'cusip',
      label: 'Cusip',
    },
    {
      name: 'symbolDescription',
      label: 'Symbol Description',
    },
    {
      name: 'startDate',
      label: 'Start Date',
    },
    {
      name: 'endDate',
      label: 'End Date',
    },
    {
      name: 'priorityType',
      label: 'Priority Type',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const v = rows[dataIndex].priorityType;

          return <div>{v === 1 ? 'Seg First' : 'Seg Last'}</div>;
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
    },
  ];

  const handleClick = (event, segregationPriorityId, removed) => {
    if (!removed) {
      const selectedIndex = selected.indexOf(segregationPriorityId);
      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, segregationPriorityId);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
      setSelected(newSelected);
      setRowID(newSelected);
    } else {
      setSelected([]);
    }
  };
  const isSelected = (segregationPriorityId) =>
    selected.indexOf(segregationPriorityId) !== -1;

  const fileName =
    'SegregationPriority_' +
    moment().format('MMMM Do YYYY, h:mm:ss a') +
    '.csv';

  const options = {
    filterType: 'select',
    download: true,
    filter: true,
    search: false,
    print: false,
    sort: true,
    viewColumns: true,
    columnOrder: [0, 1, 2, 3, 4, 5, 6, 7],
    selectableRowsHeader: false,
    selectableRows: 'none',
    rowsPerPage: 100,
    customToolbar: function() {
      return (
        <Tooltip title="Save Table" arrow>
          <IconButton onClick={() => updateTableSettings()}>
            <SaveIcon />
          </IconButton>
        </Tooltip>
      );
    },
    onDownload: () => {
      document.getElementById('csvDL').click();
      return false;
    },
    onTableChange: (action, tableState) => {
      //load table settings
      if (tableSetting.viewColumns.length === 0) {
        let req = new TableSettings();
        req.setGoogleId(googleAccount.googleId);
        req.setPageName('Segregation Priority');

        tableSettings.readTableSettings(req, {}, (err, res) => {
          if (err) {
            let req = new TableSettings();
            req.setGoogleId(googleAccount.profileObj.googleId);
            req.setUserName(googleAccount.profileObj.name);
            req.setPageName('Segregation Priority');
            req.setViewColumns(tableSetting.viewColumns.join(','));

            tableSettings.createTableSettings(req, {}, (err, res) => {
              if (err) {
                console.error(err);
                return;
              }
            });
            return;
          } else {
            let viewColumnState = res.toObject().tableSetting.viewColumns;
            let viewColumns = viewColumnState.split(',');

            for (let i = 0; i < tableState.columns.length; i++) {
              tableState.columns[i].display = viewColumns[i];
            }

            setTableSetting({
              load: true,
              viewColumns: viewColumns,
            });
          }
        });
      } else {
        if (tableSetting.load) {
          for (let i = 0; i < tableState.columns.length; i++) {
            tableState.columns[i].display = tableSetting.viewColumns[i];
          }
          tableSetting.load = false;
        }
      }

      let viewColumnState = [];

      for (let i = 0; i < tableState.columns.length; i++) {
        viewColumnState.push(tableState.columns[i].display);
      }

      tableSetting.viewColumns = viewColumnState;
    },
  };

  const [rows, setRows] = useState([]);

  const [symbolValue, setSymbolValue] = React.useState('');
  const [dateValue, setDateValue] = React.useState('');
  const [priorityTypeValue, setPriorityTypeValue] = React.useState('');
  const [statusValue, setStatusValue] = React.useState('');
  const [currentPath, setCurrentPath] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(true);

  useEffect(() => {
    const query = new URLSearchParams(params.location.search);
    const path = params.truepath;
    const data = {
      date: query.get('date'),
      symbol: query.get('symbol'),
      priorityType: query.get('priorityType'),
      status: query.get('status'),
    };

    if (data.symbol) {
      setSymbolValue(data.symbol);
    }
    if (data.priorityType) {
      setPriorityTypeValue(data.priorityType);
    }
    if (data.status) {
      setStatusValue(data.status);
    }
    if (data.date) {
      setDateValue(data.date);
    }

    //Get system date
    let profileReq = new ReadProfileRequest();

    systemDate.readProfile(profileReq, {}, (err, res) => {
      if (err) {
        console.log(err);
      } else {
        if (!data.date) {
          setDateValue(
            moment(
              new Date(formatPbDate(res.toObject().profile.systemDate))
            ).format('yyyy-MM-DD')
          );
        }
      }
    });

    setCurrentPath(path);
  }, [systemDate, params]);

  const [modalSymbolValue, setModalSymbolValue] = React.useState('');
  const [modalStartDateValue, setModalStartDateValue] = React.useState('');
  const [modalEndDateValue, setModalEndDateValue] = React.useState('');
  const [modalPriorityTypeValue, setModalPriorityTypeValue] = React.useState(
    ''
  );
  const [modalStatusValue, setModalStatusValue] = React.useState('');

  const [isDisabled, setIsDisabled] = React.useState(false);
  const [modalAddAction, setModalAddAction] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [modalTitleValue, setModalTitleValue] = React.useState('Add New');

  const [segregationPriorityId, setSegregationPriorityId] = React.useState('');
  const handleOpen = (rowData, isAdd) => {
    if (isAdd) {
      setModalStartDateValue(moment(new Date()).format('yyyy-MM-DD'));
      setModalEndDateValue(moment(new Date()).format('yyyy-MM-DD'));
      setModalPriorityTypeValue('');
      setModalSymbolValue('');
      setModalStatusValue('active');

      setModalAddAction(true);
      setIsDisabled(false);
      setModalTitleValue('Add New');
    } else {
      setModalStartDateValue(
        rowData.startDate
          ? moment(new Date(rowData.startDate)).format('yyyy-MM-DD')
          : ''
      );
      setModalEndDateValue(
        rowData.endDate
          ? moment(new Date(rowData.endDate)).format('yyyy-MM-DD')
          : ''
      );
      setModalPriorityTypeValue(rowData.priorityType);
      setModalSymbolValue(rowData.symbol);
      setModalStatusValue(rowData.status);

      setModalAddAction(false);
      setIsDisabled(true);
      setModalTitleValue('Edit');
      setSegregationPriorityId(rowData.segregationPriorityId);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {}, [modalSymbolValue]);

  return (
    <div className={classes.root}>
      <Box component="div" mt={5}>
        {showFilter ? (
          <div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <SymbolSelect
                  freeSolo={true}
                  name="symbol"
                  label="Symbol"
                  value={symbolValue}
                  onChange={(e) => {
                    setSymbolValue(e.currentTarget.value);
                  }}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <TextField
                  fullWidth
                  label="Date"
                  type="date"
                  value={dateValue}
                  onChange={(e) => setDateValue(e.target.value)}
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <InputLabel shrink>Priority Type</InputLabel>
                <Select
                  fullWidth
                  value={priorityTypeValue}
                  onChange={(e) => setPriorityTypeValue(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Blank</em>
                  </MenuItem>
                  <MenuItem value="1">Seg 1st</MenuItem>
                  <MenuItem value="3">Seg Last</MenuItem>
                </Select>
              </div>
              <div className={classes.grdCell1}>
                <InputLabel shrink>Status</InputLabel>
                <Select
                  fullWidth
                  value={statusValue}
                  onChange={(e) => setStatusValue(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Blank</em>
                  </MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </div>
            </div>
          </div>
        ) : null}
        <div className={classes.actionContainer}>
          <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              onClick={() => {
                removeSegregationPriority(
                  segregationPriority,
                  rows,
                  rowID,
                  handleClick,
                  confirm
                );
              }}
              startIcon={<DeleteIcon />}
            >
              Delete
            </Button>
          </div>
          <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<AddIcon />}
              onClick={() => {
                handleOpen('', true);
              }}
            >
              Add New
            </Button>
          </div>
          <div className={classes.grdCellNone}>
            <SearchButton
              onClick={() => search()}
              loading={loading}
              showfilter={(status) => setShowFilter(status)}
            />
          </div>
        </div>
      </Box>
      <Box component="div" mt={2}>
        {rows && (
          <CSVLink id="csvDL" data={rows} filename={fileName} target="_blank" />
        )}
        <MuiThemeProvider theme={tableTheme()}>
          <MUIDataTable
            title={'Segregation Priority'}
            data={rows}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modalBackdrop}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <div className={classes.fadeModalMd}>
            <Typography
              id="transition-modal-title"
              variant="h4"
              className={classes.textBold}
              gutterBottom
            >
              {modalTitleValue} Segregation Priority
            </Typography>
            <Box mt={5}>
              <form noValidate autoComplete="off">
                <div className={classes.grdRow}>
                  <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                    <TextField
                      label="Symbol"
                      fullWidth
                      disabled={isDisabled}
                      InputLabelProps={{ shrink: true }}
                      value={modalSymbolValue}
                      onChange={(e) => setModalSymbolValue(e.target.value)}
                    />
                  </div>
                  <div className={classes.grdCell1}>
                    <InputLabel shrink>Priority Type</InputLabel>
                    <Select
                      displayEmpty
                      fullWidth
                      disabled={isDisabled}
                      value={modalPriorityTypeValue}
                      onChange={(e) =>
                        setModalPriorityTypeValue(e.target.value)
                      }
                    >
                      <MenuItem value="1">Seg 1st</MenuItem>
                      <MenuItem value="3">Seg Last</MenuItem>
                    </Select>
                  </div>
                </div>
                <div className={classes.grdRow}>
                  <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                    <TextField
                      fullWidth
                      label="Start Date"
                      type="date"
                      disabled={isDisabled}
                      value={modalStartDateValue}
                      onChange={(e) => setModalStartDateValue(e.target.value)}
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className={classes.grdCell1}>
                    <TextField
                      fullWidth
                      label="End Date"
                      type="date"
                      disabled={isDisabled}
                      value={modalEndDateValue}
                      onChange={(e) => setModalEndDateValue(e.target.value)}
                      className={classes.textField}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </div>
                {!modalAddAction && (
                  <div className={classes.grdRow}>
                    <div className={classes.grdCell1}>
                      <InputLabel shrink>Status</InputLabel>
                      <Select
                        displayEmpty
                        fullWidth
                        value={modalStatusValue}
                        onChange={(e) => setModalStatusValue(e.target.value)}
                      >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                      </Select>
                    </div>
                  </div>
                )}
                <div className={classes.modalFooter}>
                  <div
                    className={classes.grdCellNone}
                    style={{ marginRight: 10 }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                  </div>
                  <div className={classes.grdCellNone}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={() => {
                        saveSegregationPriority(
                          segregationPriority,
                          rows,
                          modalAddAction,
                          handleClose,
                          modalSymbolValue,
                          modalStartDateValue,
                          modalEndDateValue,
                          modalPriorityTypeValue,
                          modalStatusValue,
                          segregationPriorityId
                        );
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </Box>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
